import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingStates = new Map<string, BehaviorSubject<boolean>>();
  private globalLoading = new BehaviorSubject<boolean>(false);

  constructor() {}

  startLoading(componentId: string): void {
    if (!this.loadingStates.has(componentId)) {
      this.loadingStates.set(componentId, new BehaviorSubject<boolean>(true));
    } else {
      this.loadingStates.get(componentId)?.next(true);
    }
    this.updateGlobalLoadingState();
  }

  stopLoading(componentId: string): void {
    if (this.loadingStates.has(componentId)) {
      this.loadingStates.get(componentId)?.next(false);
    }
    this.updateGlobalLoadingState();
  }

  getLoadingState(componentId: string): Observable<boolean> {
    if (!this.loadingStates.has(componentId)) {
      this.loadingStates.set(componentId, new BehaviorSubject<boolean>(false));
    }
    return this.loadingStates.get(componentId)!.asObservable();
  }

  getGlobalLoadingState(): Observable<boolean> {
    return this.globalLoading.asObservable();
  }

  private updateGlobalLoadingState(): void {
    let anyLoading = false;
    for (const [_, loadingState] of this.loadingStates) {
      if (loadingState.value === true) {
        anyLoading = true;
        break;
      }
    }
    this.globalLoading.next(anyLoading);
  }
}